/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HttpPolicySetModule
 */

import { HTTPHdrData } from 'object-types';

import {
    IHTTPHdrData,
    IHTTPHdrValue,
} from 'generated-types';

import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';

type THTTPHdrData = Omit<IHTTPHdrData, 'value'>;

type THTTPHdrValue = Omit<IHTTPHdrValue, 'var'>;

interface IHTTPHdrValueConfig extends THTTPHdrValue {
    var: string
}
interface IHTTPHdrDataConfig extends THTTPHdrData {
    value: MessageItem<IHTTPHdrValueConfig>
}

/**
 * @description HTTPHdrData ConfigItem.
 *
 * @author Abhinesh Gour
 */
export class HTTPHdrDataConfigItem extends MessageItem<IHTTPHdrDataConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: HTTPHdrData,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * @override
     */
    protected modifyConfigDataAfterLoad(): void {
        super.modifyConfigDataAfterLoad();

        const { value } = this.config;

        if (!value) {
            this.safeSetNewChildByField('value');
        }
    }
}
